import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Clock } from 'lucide-react';

const pad = (n) => String(n).padStart(2, '0');

const CountdownTimer = ({ activateAt, serverTime, onComplete }) => {
  const { language } = useLanguage();
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (!activateAt || !serverTime) return;
    // Calculate drift between server and client, then use client clock
    const target = new Date(activateAt).getTime();
    const serverNow = new Date(serverTime).getTime();
    const clientNow = Date.now();
    const drift = serverNow - clientNow; // ms

    const tick = () => {
      const r = Math.max(0, target - (Date.now() + drift));
      setRemaining(r);
      if (r <= 0 && onComplete) onComplete();
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [activateAt, serverTime, onComplete]);

  if (!activateAt || remaining <= 0) return null;

  const totalSec = Math.floor(remaining / 1000);
  const hours = Math.floor(totalSec / 3600);
  const mins = Math.floor((totalSec % 3600) / 60);
  const secs = totalSec % 60;

  const label = language === 'fi' ? 'Uusi lounaslista alkaa' : 'New lunch menu in';

  return (
    <div className="max-w-2xl mx-auto mb-10">
      <div className="bg-gradient-to-r from-[#7A1F25] to-[#9B2730] text-white rounded-2xl p-6 shadow-lg border border-[#B8934A]/30">
        <div className="flex items-center justify-center gap-3 mb-3">
          <Clock className="text-[#D4A94B]" size={20} />
          <span className="text-[#D4A94B] text-xs md:text-sm tracking-[0.25em] uppercase font-medium">{label}</span>
        </div>
        <div className="flex items-center justify-center gap-3 md:gap-5">
          <TimeBlock value={pad(hours)} label={language === 'fi' ? 'Tuntia' : 'Hours'} />
          <span className="font-serif text-3xl md:text-5xl text-[#D4A94B] leading-none">:</span>
          <TimeBlock value={pad(mins)} label={language === 'fi' ? 'Minuuttia' : 'Minutes'} />
          <span className="font-serif text-3xl md:text-5xl text-[#D4A94B] leading-none">:</span>
          <TimeBlock value={pad(secs)} label={language === 'fi' ? 'Sekuntia' : 'Seconds'} />
        </div>
      </div>
    </div>
  );
};

const TimeBlock = ({ value, label }) => (
  <div className="flex flex-col items-center min-w-[60px] md:min-w-[80px]">
    <div className="font-serif text-3xl md:text-5xl font-semibold text-white leading-none tabular-nums">{value}</div>
    <div className="text-[10px] md:text-xs uppercase tracking-wider text-white/60 mt-2">{label}</div>
  </div>
);

export default CountdownTimer;
